"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _uiUtils = require("@airasia/ui-utils");

var styles = _crossPlatformComponents.StyleSheet.create({
  passengerRowMobileView: {
    flex: 1,
    flexDirection: 'row',
    marginVertical: 20,
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB,
      fontWeight: '400'
    }
  },
  mobileViewForm: {
    flex: 1,
    flexDirection: 'column',
    marginTop: 15,
    padding: 16
  },
  widgetModalContainer: {
    position: 'absolute',
    web: {
      position: 'fixed'
    },
    top: 0,
    left: 0,
    width: '100%'
  },
  safeAreaView: {
    flex: 1,
    backgroundColor: "transparent",
    ios: {
      backgroundColor: 'white'
    }
  },
  modal: {
    flex: 1,
    ios: {
      height: '100%'
    },
    android: {
      height: '100%'
    },
    backgroundColor: '#fff'
  },
  mobileScreenContainer: {
    paddingVertical: 15,
    borderColor: "#fff",
    //  borderWidth: 1,
    borderRadius: 4,
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    zIndex: -1
  },
  upperContainer: {
    flexDirection: 'row',
    flex: 8
  },
  lowerContainer: {
    flexDirection: 'row',
    flex: 8,
    marginBottom: 15,
    zIndex: -1,
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  elementContainer: {
    web: {
      position: 'relative',
      zIndex: '10000'
    }
  },
  calendarContainer: {
    flex: 4
  },
  buttonContainer: {
    paddingHorizontal: 0,
    maxWidth: 183
  },
  hide: {
    display: 'none'
  },
  show: {
    web: {
      display: 'block',
      marginVertical: 0,
      width: '100%',
      marginHorizontal: 'auto',
      maxWidth: '596',
      minHeight: '56'
    },
    zIndex: -999
  },
  onDesktopButton: {
    web: {
      paddingHorizontal: 0,
      maxWidth: 183
    }
  },
  spaceBetween: {
    marginRight: 'auto'
  },
  setFlex: {
    flex: 1
  },
  searchView: {
    flex: 1,
    web: {
      flexDirection: 'column',
      backgroundColor: '#FFFFFF',
      padding: 10,
      borderRadius: 10,
      minHeight: 150
    }
  },
  searchControls: {
    flex: 1,
    flexDirection: 'row',
    marginBottom: 10,
    zIndex: 2
  },
  searchViewItem: {
    flex: 1,
    flexDirection: 'row',
    marginBottom: 10
  },
  columnFlexDirection: {
    web: {
      flexDirection: 'column'
    }
  },
  continueButtonSection: {
    flex: 2,
    web: {
      flexDirection: 'column',
      justifyContent: 'flex-start'
    }
  },
  buttonStyle: {
    backgroundColor: '#e10000',
    height: 56,
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttonText: {
    color: '#fff'
  },
  aaTextInputContainerStyle: {
    height: 35,
    android: {
      width: '35%',
      marginVertical: 4,
      justifyContent: 'center'
    },
    ios: {
      width: '35%',
      marginVertical: 4,
      justifyContent: 'center'
    },
    web: {
      width: 210,
      alignSelf: 'flex-end'
    }
  },
  aaTextInputStyle: {
    paddingVertical: 7,
    paddingHorizontal: 14,
    width: '100%',
    left: 0,
    marginTop: 0,
    fontSize: 16
  },
  TabletView: {
    web: {
      display: 'block',
      marginBottom: 85
    }
  },
  desktopWidth: {
    web: {
      width: '50%'
    }
  }
});

var _default = styles;
exports["default"] = _default;